import React from 'react';
import PropTypes from 'prop-types';

import { Popover } from 'react-tiny-popover';

const ImportantInformation = ({ isPopoverOpen, handleImportantInformation }) => (
  <div className="text-left font-medium text-[14px] leading-[16px] text-black mt-[20px]">
    Important information about procedures for opening a new account;
    <Popover
      isOpen={isPopoverOpen}
      positions={['top']} // preferred positions by priority
      align="start"
      padding={10}
      onClickOutside={handleImportantInformation.bind(this, false)}
      content={(
        <>
          <div className="rounded-md border border-[#00214732] p-5 bg-[#ffffff] m-auto max-w-[90%] md:max-w-[400px] max-h-[500px] overflow-y-auto text-[#3f556e] text-[14px]">
            <p>To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.</p>
            <p>What this means for you: When you open an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver&apos;s license or other identifying documents.</p>
          </div>
          <span className="arrow left-2 hidden md:block" />
        </>
      )}
    >
      <span className="underline cursor-pointer pr-1 text-[#3989e3] ml-1" onClick={handleImportantInformation.bind(this, !isPopoverOpen)}>USA PATRIOT Act Notice</span>
    </Popover>
  </div>
);

ImportantInformation.propTypes = {
  isPopoverOpen: PropTypes.func.isRequired,
  handleImportantInformation: PropTypes.func.isRequired,
};

export default ImportantInformation;
